import logo from "assets/icons/shopwerk.svg";
import { useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootReduxState } from "../../../../../utils/types";
import { AvailableIntegrationCardAddButton } from "../../components/AvailableIntegrationCardAddButton";
import { AvailableIntegrationCardExplanationWrapper } from "../../components/AvailableIntegrationCardExplanationWrapper";
import { AvailableIntegrationCardHeader } from "../../components/AvailableIntegrationCardHeader";
import { AvailableIntegrationCardWrapper } from "../../components/AvailableIntegrationCardWrapper";
import { ConnectViewComponentProps, IntegrationType } from "../../types";
import { ShopwerkConnectModal } from "./ConnectModal";
import {
  ShopwerkDataReduxState,
  ShopwerkRequestReduxState,
  getShopwerkIntegrationSettingsAction
} from "./redux";

type ShopwerkConnectViewComponentOwnProps = ConnectViewComponentProps;

const mapStateToProps = (state: RootReduxState) => {
  const selectedShopId = state.getIn([
    "customerBackendDashboard",
    "userData",
    "selectedShopId"
  ]) as string;

  const getRequestState = state
    .getIn(["integrations", "shopwerk", "requests", "get"])
    .toJS() as ShopwerkRequestReduxState;

  return {
    selectedShopId: Number(selectedShopId),
    isLoading: getRequestState.loading,
    integrationData: state.getIn(["integrations", "shopwerk", "data"])?.toJS() as
      | ShopwerkDataReduxState
      | undefined
  };
};
const matchDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getShopwerkIntegrationSettingsAction
    },
    dispatch
  );
const connector = connect(mapStateToProps, matchDispatchToProps);

type ShopwerkConnectViewComponentProps = ShopwerkConnectViewComponentOwnProps &
  ConnectedProps<typeof connector>;

const ShopwerkConnectViewComponent = (props: ShopwerkConnectViewComponentProps) => {
  const {
    connectingType,
    onStartConnecting,
    onStopConnecting,
    integrationData,
    getShopwerkIntegrationSettingsAction,
    selectedShopId,
    isLoading
  } = props;

  useEffect(() => {
    getShopwerkIntegrationSettingsAction(selectedShopId);
  }, []);

  const handleConnect = useCallback(() => {
    onStartConnecting(IntegrationType.SHOPWERK);
  }, [onStartConnecting]);

  const isConnected = integrationData?.settings !== undefined;

  return (
    <AvailableIntegrationCardWrapper>
      {connectingType === IntegrationType.SHOPWERK && (
        <ShopwerkConnectModal handleClose={onStopConnecting} />
      )}
      <AvailableIntegrationCardHeader image={logo} text="Shopwerk" />
      <AvailableIntegrationCardExplanationWrapper>
        <FormattedMessage
          id="containers.Integrations.ListOfApps.Shared.Short.Explanation"
          defaultMessage="Connect your Shopwerk account with uptain. Then new newsletter subscribers can be added to your account."
          values={{ tool: "Shopwerk" }}
        />
      </AvailableIntegrationCardExplanationWrapper>
      <AvailableIntegrationCardAddButton
        isConnected={isConnected}
        loading={isLoading || connectingType !== undefined}
        onConnect={handleConnect}
      />
    </AvailableIntegrationCardWrapper>
  );
};

export const ShopwerkConnectView = connector(ShopwerkConnectViewComponent);
